import React from "react";
import RoleCard from "./RoleCard";
import RoleChips from "./RoleChips";
import { ROLE_OPTIONS } from "../../../constants/roles";

export default function RoleSelector({
  roles,
  onToggle,
  onSelectAll,
  onClear,
  disabled = false,
  invalid = false,
  invalidText = "Select at least one role.",
}) {
  return (
    <div className="mb-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <label className="form-label mb-0">Roles</label>
        <div className="d-flex gap-2">
          <button
            type="button"
            className="ui-btn"
            onClick={onSelectAll}
            disabled={disabled}
          >
            Select all
          </button>
          <button
            type="button"
            className="ui-btn"
            onClick={onClear}
            disabled={disabled}
          >
            Clear
          </button>
        </div>
      </div>

      <div className="mb-2">
        <RoleChips roles={roles} />
      </div>

      <div className="row g-3">
        {ROLE_OPTIONS.map((option) => (
          <div className="col-12 col-md-6" key={option.value}>
            <RoleCard
              option={option}
              checked={roles?.includes(option.value)}
              onToggle={() => onToggle?.(option.value)}
              disabled={disabled}
            />
          </div>
        ))}
      </div>

      {invalid && (
        <div className="text-danger small mt-2">{invalidText}</div>
      )}
    </div>
  );
}
